import React from 'react';
import { Link2 } from 'lucide-react';

// Internal-only: page + CTA the customer came from (consultations and quote requests).
export const ConsultationSource = ({ c, hideIfMissing = false, testPrefix = 'consultation-source' }) => {
  if (!c.source_title && !c.source_path) return hideIfMissing ? null : <p className="text-xs text-neutral-400 mt-1" data-testid={`${testPrefix}-${c.id}`}>Source: not recorded</p>;
  const when = c.source_clicked_at ? new Date(c.source_clicked_at).toLocaleString('en-US', { timeZone: 'America/New_York', dateStyle: 'medium', timeStyle: 'short' }) + ' ET' : null;
  return (
    <div className="mt-2 inline-flex flex-wrap items-center gap-x-2 gap-y-0.5 text-xs text-neutral-600 bg-neutral-50 border border-neutral-200 rounded px-2 py-1" data-testid={`${testPrefix}-${c.id}`}>
      <Link2 className="w-3.5 h-3.5 text-neutral-400" />
      <span className="font-medium text-neutral-800" data-testid={`${testPrefix}-title`}>{c.source_title}</span>
      {c.source_path && <a href={c.source_url || c.source_path} target="_blank" rel="noreferrer" className="underline text-neutral-500 hover:text-neutral-900" data-testid={`${testPrefix}-url`}>{c.source_url || c.source_path}</a>}
      {c.source_cta && <span data-testid={`${testPrefix}-cta`}>· “{c.source_cta}”</span>}
      {when && <span className="text-neutral-400" data-testid={`${testPrefix}-time`}>· {when}</span>}
    </div>
  );
};

export const LeadSourceChip = ConsultationSource;
